import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@cmps/ng-bootstrap';
import { SelectModule } from '@cmps/ng-select';
import {
    CmpsButtonGroupModule,
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsRadioModule,
    CmpsTooltipModule,
    CmpsUserInfoModule,
} from '@cmps/ng-uikit';

import { NextCoachingInsightService } from '../coaching-base/coaching-insight.service';
import { CmpsChartModule } from '../coaching-commitment/chart.module';
import { CmpsCommitmentModule } from '../coaching-commitment/coaching-commitment.module';
import { CmpsObservationModule } from '../coaching-observation/coaching-observation.module';
import { ExperimentalNgGridModule } from '../coaching-observation/experimental.grid';
import { ExperimentalPopUpModule } from '../coaching-observation/experimental.pop-up';
import { CmpsCoachingWinningPercentageModule } from '../coaching/insight/winning-percentage';
import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { CmpsInsightModule } from '../insight/insight.module';
import { CmpsMi2Module } from '../scorecard-mi2/mi2.module';
import { CmpsUserModule } from '../user/user.module';
import { Widgets } from '../widget/widget.model';
import { CmpsWidgetModule } from '../widget/widget.module';

import { CoachingCoverageGridComponent } from './coaching-coverage/coaching-coverage-grid.component';
import { CoachingCoverageComponent } from './coaching-coverage/coaching-coverage.component';
import { ScheduleCellComponent } from './coaching-coverage/schedule-cell.component';
import { ScheduleItemComponent } from './coaching-coverage/schedule-item.component';
import { ScheduleItemsListComponent } from './coaching-coverage/schedule-items-list.component';
import { SelectPeriodDateRangeComponent } from './coaching-coverage/select-period-date-range.component';
import { SelectPeriodRangeComponent } from './coaching-coverage/select-period-range.component';
import { TranslationIdMap as coachingInsightTranslationIdMap } from './coaching-insight.i18n';
import { CoverageCoachingInsightService } from './coverage.coaching-insight.service';
import { CoachingInsightWidgetComponentNext } from './insight-widget/insight-widget.component';
import { CmpsInsightWidgetModule } from './insight-widget/insight-widget.module';
import { OldCoachingInsightWidgetComponent } from './oa-old/coaching-insight.widget.component';
import { OldLineAreaComponent } from './oa-old/line-area.component';
import { OaWidgetWrapperComponent } from './oa-old/oa-widget-wrapper.component';
import {
    CoachingComponent,
    CoachingComponentStripComponent,
    CoachingComponentSubmenu,
} from './oa/coaching-component-strip.component';
import { CoachingFilter } from './oa/coaching-filter.component';
import { CoachingInsightWidgetComponent } from './oa/coaching-insight.widget.component';
import { DocumentBlurTriggerDirective } from './oa/document-blur-trigger.directive';
import { ElasticElementDirective } from './oa/elastic-element.directive';
import { ElasticTabsComponent } from './oa/elastic-tabs.component';
import { ForceDropdownPositionDirective } from './oa/force-dropdown-position.directive';
import { FractionBarComponent } from './oa/fraction-bar.component';
import { FrontlineMetricRowComponent } from './oa/frontline/frontline-metric-row.component';
import { FrontlineOAComponent } from './oa/frontline/frontline-oa.component';
import { FrontlinePersonRowComponent } from './oa/frontline/frontline-person-row.component';
import { HistorySortArrow } from './oa/history-sort-arrow.pipe';
import { CommitmentsHistoryComponent } from './oa/opportunityalignment/commitments-history.component';
import { DebounceClickDirective } from './oa/opportunityalignment/debounce-click.directive';
import { GoalScoreComponent } from './oa/opportunityalignment/goal-score.component';
import { GoalsHistoryComponent } from './oa/opportunityalignment/goals-history.component';
import { MetricButtonComponent } from './oa/opportunityalignment/metric-button.component';
import { MetricListComponent } from './oa/opportunityalignment/metric-list.component';
import { OALegendComponent } from './oa/opportunityalignment/oa-legend.component';
import { OaPopulationStatusPipe } from './oa/opportunityalignment/oapopulationstatus.pipe';
import { ObservationsHistoryComponent } from './oa/opportunityalignment/observations-history.component';
import { PersonListComponent } from './oa/opportunityalignment/person-list.component';
import { PersonOAHistoryComponent } from './oa/opportunityalignment/person-oa-history.component';
import { PersonPerformanceDataGridComponent } from './oa/opportunityalignment/person-performance-data-grid.component';
import { PersonPerformanceVarianceComponent } from './oa/opportunityalignment/person-performance-variance.component';
import { PersonRowComponent } from './oa/opportunityalignment/person-row.component';
import { TeamOACurrentCommitmentsComponent } from './oa/opportunityalignment/team-oa-current-commitments.component';
import { TeamOAMetricsComponent } from './oa/opportunityalignment/team-oa-metrics.component';
import { TeamOARowDetailsComponent } from './oa/opportunityalignment/team-oa-row-details.component';
import { TeamViewTabsComponent } from './oa/opportunityalignment/team-view-tabs.component';
import { SafePipe } from './oa/safe.pipe';
import { CoachingInsightWidgetService } from './oa/services/coaching-insight.widget.service';
import { CoachingService } from './oa/services/coaching.service';
import { ElasticUIService } from './oa/services/elastic-ui.service';
import { FrontlineOAService } from './oa/services/frontline-oa.service';
import { PersonOfInterestService } from './oa/services/person-of-interest.service';
import { TeamOAService } from './oa/services/team-oa.service';
import { TeamViewSelector } from './oa/team-view-selector.component';
import { TrendArrow } from './oa/trend-arrow.pipe';
import {
    CmpsUIDropdownComponent,
    TriggerReferenceDirective,
} from './oa/ui-dropdown.component';
import { ScheduleCoachingInsightService } from './schedule.coaching-insight.service';
import { CmpsScheduleModule } from './schedule/schedule.module';
import { StickyHeaderDirective } from './stickyheader/stickyheader.directive';

export const OldOaWidgetTypeId = 22;

const ModuleWidgets: Widgets = [
    {
        typeId: OldOaWidgetTypeId,
        component: OaWidgetWrapperComponent,
        noEncapsulate: true,
    },
    {
        typeId: 25,
        component: CoachingInsightWidgetComponentNext,
        noEncapsulate: true,
    },
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        SelectModule,

        CmpsLazyI18nModule.forChild(coachingInsightTranslationIdMap),
        CmpsCommonModule,
        CmpsWidgetModule.forChild(ModuleWidgets),
        CmpsUserModule,
        CmpsInsightModule,
        CmpsObservationModule,
        CmpsCommitmentModule,
        CmpsChartModule,
        ExperimentalNgGridModule,
        ExperimentalPopUpModule,
        CmpsScheduleModule.forRoot(),
        CmpsUserInfoModule,
        CmpsMi2Module,
        CmpsIconModule,
        CmpsButtonModule,
        CmpsRadioModule,
        CmpsCoachingWinningPercentageModule,
        CmpsButtonGroupModule,
        CmpsTooltipModule,
        CmpsDialogModule,
        CmpsInsightWidgetModule,
    ],
    declarations: [
        CoachingInsightWidgetComponent,
        CoachingInsightWidgetComponentNext,
        CoachingCoverageComponent,
        CoachingComponentStripComponent,
        CoachingComponent,
        CoachingComponentSubmenu,

        CoachingFilter,

        TeamOAMetricsComponent,
        TeamViewTabsComponent,
        TeamOACurrentCommitmentsComponent,
        GoalsHistoryComponent,
        CommitmentsHistoryComponent,
        ObservationsHistoryComponent,
        TeamOARowDetailsComponent,

        PersonRowComponent,
        PersonPerformanceDataGridComponent,
        PersonPerformanceVarianceComponent,
        PersonOAHistoryComponent,

        FrontlineOAComponent,
        FrontlinePersonRowComponent,
        FrontlineMetricRowComponent,
        FractionBarComponent,

        HistorySortArrow,
        TrendArrow,

        TeamViewSelector,
        TriggerReferenceDirective,
        ElasticTabsComponent,
        ElasticElementDirective,
        ForceDropdownPositionDirective,

        OaPopulationStatusPipe,

        CmpsUIDropdownComponent,
        PersonListComponent,

        OALegendComponent,

        ScheduleItemComponent,
        ScheduleCellComponent,
        SelectPeriodRangeComponent,
        SelectPeriodDateRangeComponent,
        ScheduleItemsListComponent,
        CoachingCoverageGridComponent,

        OldLineAreaComponent,
        OldCoachingInsightWidgetComponent,
        OaWidgetWrapperComponent,

        MetricButtonComponent,
        MetricListComponent,
        GoalScoreComponent,
        StickyHeaderDirective,
        SafePipe,
        DocumentBlurTriggerDirective,
        DebounceClickDirective,

        // TooltipDirective,
        // TooltipComponent,
        // TooltipContainerDirective,
    ],
    providers: [
        SafePipe,
        CoverageCoachingInsightService,
        ScheduleCoachingInsightService,
    ],
    exports: [CoachingInsightWidgetComponentNext],
})
export class CmpsCoachingInsightModule {
    static forRoot(): ModuleWithProviders<CmpsCoachingInsightModule> {
        return {
            ngModule: CmpsCoachingInsightModule,
            providers: [
                CoachingInsightWidgetService,
                NextCoachingInsightService,
                TeamOAService,
                FrontlineOAService,
                CoachingService,
                PersonOfInterestService,
                ElasticUIService,
                OaPopulationStatusPipe,
            ],
        };
    }
}
